import { render, staticRenderFns } from "./retencoes.vue?vue&type=template&id=638d112d"
import script from "./retencoes.ts?vue&type=script&lang=js&external"
export * from "./retencoes.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638d112d')) {
      api.createRecord('638d112d', component.options)
    } else {
      api.reload('638d112d', component.options)
    }
    module.hot.accept("./retencoes.vue?vue&type=template&id=638d112d", function () {
      api.rerender('638d112d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfe/retencoes.vue"
export default component.exports